const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');

const SIDE_MENU_VALUES = [
  {text:'left',  value:'left'},
  {text:'right', value:'right'},
];

const B008_VALUES = [
    {text:'short',  value:'body_fart_position_sneaky'},
    {text:'medium', value:'body_fart_position_left'},
    {text:'long',   value:'extra_long_fart'},
];

const MUSICAL_SCALE_VALUES =[
    {text:'c low', value:'c'},
    {text:'d', value:'d'},
    {text:'e', value:'e'},
    {text:'f', value:'f'},
    {text:'g', value:'g'},
    {text:'a', value:'a'},
    {text:'b', value:'b'},
    {text:'c high', value:'c4'},
]


const BIG_SMALL_LONG_VALUES = [
  {text:'short',  value:'small'},
  {text:'medium', value:'big'},
  {text:'long',   value:'long'},
];

const SMALL_LONG_VALUES = [
  {text:'short',  value:'small'},
  {text:'long',   value:'long'},
];

const WIND_INSTRUMENTS_BLOCKS = [
  { opcode:'wind_burp_body_scale', text:'burp note [MUSICAL_SCALE]', args:{MUSICAL_SCALE:'musicalScale'}, anim:{name:'burp_body_scale', variant:'{MUSICAL_SCALE}', loops:1} }, //B005
  { opcode:'wind_fart_body_scale', text:'fart note [MUSICAL_SCALE]', args:{MUSICAL_SCALE:'musicalScale'}, anim:{name:'fart_body_scale', variant:'{MUSICAL_SCALE}', loops:1} }, // B006
  { opcode:'wind_big_burp', text:'burp body [TYPE]', args:{TYPE:{menu:'bigSmallLongMenu', type:'string'}}, anim:{name:'body_burp_{TYPE}', loops:1} }, //B007
  { opcode:'wind_fart_position', text:'fart body [TYPE]', args:{TYPE:{menu:'B008_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B008
];

function argSpec(argKey, spec) {
  if (typeof spec === 'string') return { type: ArgumentType.STRING, menu: spec };
  const t = spec?.type === 'number' ? ArgumentType.NUMBER : ArgumentType.STRING;
  return spec?.menu ? { type: t, menu: spec.menu } : { type: t };
}

function interpolate(tpl, args) {
  return String(tpl).replace(/\{(\w+)\}/g, (_, k) => String(args[k] ?? '').replace(/\s+/g,'_'));
}

function toNumberMaybe(v) {
  const n = Number(v); return Number.isFinite(n) ? n : undefined;
}

const buildBlocks = (rawBlocks) => rawBlocks.map(b => ({
    opcode: b.opcode,
    blockType: BlockType.COMMAND,
    text: b.text,
    arguments: Object.fromEntries(Object.entries(b.args || {}).map(([k, spec]) => ([k, argSpec(k, spec)])))
}));

function getBlockHandler(b) {
    return function(args) { 
        const op = b.anim.op || 'play_animation';
        if (op === 'play_animation') {
            const name = interpolate(b.anim.name, args);
            const variant = b.anim.variant ? interpolate(b.anim.variant, args) : 'default';
            const loops = typeof b.anim.loops === 'string' ? toNumberMaybe(args[b.anim.loops.replace(/[{}]/g, '')]) ?? 1 : (b.anim.loops ?? 1);
            const payload = `{"animName":"${name}","state":"true","variantKey":"${variant}","loops":${loops}}`;
            return this.sendWaitAck({ OP: op, PAYLOAD: payload, TIMEOUT: -1 });
        } else {
            const payload = `{}`;
            return this.sendWaitAck({ OP: op, PAYLOAD: payload, TIMEOUT: -1 });
        }
    };
}

class Scratch3CodematesWind {
    constructor(runtime) {
        this.runtime = runtime;
        this._pending = new Map();
        this._events = new Map();
        this._awaiters = new Map();
        this._onUnityMessage = this._onUnityMessage.bind(this);
        window.addEventListener('unity-message', this._onUnityMessage);
        this.installHandlers(WIND_INSTRUMENTS_BLOCKS);
    }

    initWebGL() { this.sendNow({ OP:'unity_init' }); }
    resetWebGL() { this.sendNow({ OP:'unity_cleanUp' }); }
    
    getInfo() {
        return {
            id: 'codematesWind',
            name: '💨 Patch\'s Wind Instruments',
            color1: '#764AD2', // Purple
            blocks: buildBlocks(WIND_INSTRUMENTS_BLOCKS),
            menus: {
                sideMenu: { acceptReporters: false, items: SIDE_MENU_VALUES },
                B008_menu: { acceptReporters: false, items: B008_VALUES },
                musicalScale: { acceptReporters: false, items: MUSICAL_SCALE_VALUES },
                bigSmallLongMenu: { acceptReporters: false, items: BIG_SMALL_LONG_VALUES },
                smallLongMenu: { acceptReporters: false, items: SMALL_LONG_VALUES },
            }
        };
    }
    
    installHandlers(blocks) {
        for (const b of blocks) { this[b.opcode] = getBlockHandler(b).bind(this); }
    }

    // RPC Logic
    sendNow(args) {
        window.__codemates_seq = window.__codemates_seq || 0;
        const op = Cast.toString(args.OP);
        const payload = this._parse(Cast.toString(args.PAYLOAD || '{}'));
        this._post({ seq: ++this._seq, op, data: payload });
    }

    sendWaitAck(args) {
        const op = Cast.toString(args.OP);
        const payload = this._parse(Cast.toString(args.PAYLOAD));
        const n = Number(args.TIMEOUT);
        const timeout = Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
        return this._rpc(op, payload, { waitFor: 'ack', timeout });
    }

    _rpc(op, payload = {}, { timeout = 2000, waitFor } = {}) {
        window.__codemates_seq = window.__codemates_seq || 0;
        const seq = ++window.__codemates_seq;
        const body = { seq, op, data: payload };
        const p = new Promise((resolve, reject) => {
            let t = null;
            if (timeout) {
                t = setTimeout(() => { this._pending.delete(seq); resolve({ seq, op, timeout: true }); }, timeout);
            }
            this._pending.set(seq, { resolve, reject, t, waitFor });
        });
        this._post(body);
        return p;
    }

    _post(body) {
        if (typeof window.sendToUnity === 'function') { try { window.sendToUnity(body); } catch {} }
        else { (window.__unityQueue = window.__unityQueue || []).push(body); }
    }

    _parse(s) {
        try { const o = JSON.parse(s); return typeof o === 'object' && o !== null ? o : { value: s }; }
        catch { return { value: s }; }
    }

    _queueEvent(name, data) {
        const q = this._events.get(name) || [];
        q.push(data);
        this._events.set(name, q);
        const aw = this._awaiters.get(name);
        if (aw && aw.length) aw.shift()();
        this.runtime.startHats('codemates_whenUnityEvent', { EVENT: name });
    }

    _popEvent(name) {
        const q = this._events.get(name) || [];
        if (!q.length) return false;
        q.shift();
        return true;
    }

    _waitForEvent(name) {
        if (this._popEvent(name)) return Promise.resolve();
        return new Promise(r => {
            const list = this._awaiters.get(name) || [];
            list.push(r);
            this._awaiters.set(name, list);
        });
    }

    _onUnityMessage(evt) {
        const msg = evt && (evt.detail || evt.data);
        if (!msg || typeof msg !== 'object') return;
        if (msg.type === 'event' && msg.name) { this._queueEvent(msg.name, msg); return; }
        if (msg.seq && this._pending.has(msg.seq)) {
            const entry = this._pending.get(msg.seq);
            if (entry.t) clearTimeout(entry.t);
            if (!entry.waitFor || entry.waitFor === msg.type || msg.type === 'error') {
                this._pending.delete(msg.seq);
                if (msg.type === 'error') entry.reject(new Error(msg.error || 'unity error'));
                else entry.resolve(msg);
            }
        }
    }
}


module.exports = Scratch3CodematesWind;
